var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowImage)?_c('div',{staticClass:"bbox-container"},_vm._l((_vm.bbox),function(bbox,index){return _c('div',{key:index,staticClass:"bbox",style:(_vm.getBboxStyle(bbox, index)),on:{"mouseenter":function($event){return _vm.highlightBbox(index)},"mouseleave":_vm.unhighlightBbox}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }